<style scoped>
.total-input * {
  font-size: .8rem !important;
}
</style>

<template>
  <div>
    <b-row>
      <b-col md="12" class="text-right" v-if="hideInput">
        <span @click="editTotal" class="h5">{{formattedTotal}}</span>
      </b-col>
      <b-col md="12" class="mb-1" v-if="!hideInput">
        <b-input-group
          prepend="Total"
          class="total-input"
        >
          <b-form-input
            v-model="model.total"
            type="number"
            ref="totalInput"
            @blur.native="handleBlur"
          />
          <b-input-group-append>
            <b-button variant="danger" @click="zeroTotal" :class="deleteBtnClass">
              <font-awesome-icon icon="eraser" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faEraser } from '@fortawesome/free-solid-svg-icons';
import VueFormGenerator from 'vue-form-generator';
import numbro from 'numbro';

library.add([faCheck, faEraser]);
export default {
  components: {
    'vue-form-genertor': VueFormGenerator.component,
  },
  props: ['total'],
  data() {
    return {
      deleteBtnClass: 'delete-total-btn',
      hideInput: true,
      model: { total: 0.00 },
    };
  },
  methods: {
    handleBlur(event) {
      const deleteHasFocus = (
        event.relatedTarget &&
        event.relatedTarget.classList.contains(this.deleteBtnClass)
      );

      if (!deleteHasFocus) { this.updateTotal(); }
    },
    updateTotal() {
      this.hideInput = true;
      this.$emit('total-changed', this.model.total);
    },
    editTotal() {
      this.model.total = this.total;
      this.hideInput = false;
      this.$nextTick(() => this.$refs.totalInput.focus());
      this.$emit('edit-total');
    },
    zeroTotal() {
      this.model.total = 0.00;
      this.updateTotal();
    },
  },
  computed: {
    formattedTotal() {
      return numbro(this.total).formatCurrency({ thousandSeparated: true, mantissa: 2 });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/estimate_of_repairs/EditableTotal.vue